/* Polsk katalog for locale-payroll-delivery-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'err.payslip.notAuthorized': 'Nie masz dostępu do tego żądania wysyłki.',
  'err.payslip.approvedRunRequired': 'Zatwierdź listę płac, zanim paski wynagrodzeń zostaną dodane do kolejki.',
  'err.payslip.queueTooLarge': 'Dane pasków wynagrodzeń są zbyt duże, aby dodać je do kolejki. Skontaktuj się z pomocą techniczną.',
  'pay.payslipSent': 'Pasek wynagrodzenia wysłany.',
  'pay.payslipsSent': 'Paski wynagrodzeń wysłane.',
  'pay.payslipsSentAndPosted': 'Paski wynagrodzeń wysłane, a wynagrodzenia zaksięgowane.',
  'pay.payslipsQueuedAndPosted': 'Wynagrodzenia zaksięgowane. Paski wynagrodzeń dodano do kolejki wysyłki.',
  'pay.payslipQueued': 'W kolejce do wysyłki',
  'pay.payslipsQueued': 'Paski wynagrodzeń w kolejce do wysyłki.',
  'pay.payslipGenerated': 'Wygenerowano',
  'pay.payslipNotReady': 'Niegotowy',
  'pay.payslipScheduled': 'Zaplanowano',
});
